module.exports = __webpack_public_path__ + "img/logo.0a1144e0.png";